import {AsyncPipe, NgClass} from '@angular/common';
import {Component, inject} from '@angular/core';
import {MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {BreakpointService} from 'src/app/shared/services/breakpoint/breakpoint.service';

@Component({
  selector: 'app-instadesk-dialog',
  imports: [
    AsyncPipe,
    NgClass,
    MatDialogContent,
  ],
  templateUrl: './instadesk-dialog.component.html',
  styleUrl: './instadesk-dialog.component.scss',
})
export class InstadeskDialogComponent {
  private breakpointService = inject(BreakpointService);
  deviceSize$ = this.breakpointService.deviceSize$;

  dialogRef = inject<MatDialogRef<InstadeskDialogComponent>>(MatDialogRef);

  close() {
    this.dialogRef.close();
  }
}
